import companyFormFields from "./CompanyFormFields";

// The profile wizard's company step. The settings page edits the same fields a section
// at a time in a modal, so only the wizard lays the form out whole.
const UpdateSettingsForm = ({ formik, isEditable, isFreelanceCompany }) => {
  const fields = companyFormFields(formik, { disabled: !isEditable, isFreelanceCompany });

  return (
    <div className="h-[60vh] overflow-y-auto pr-2">
      <form
        onSubmit={formik.handleSubmit}
        className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-y-5 pt-7 pb-12 text-black"
      >
        {fields.registrationNumber}
        {fields.registrationCertificate}
        {fields.vatNumber}
        {fields.searchAddress}
        {fields.address}
        {fields.city}
        {fields.country}
        {fields.zipCode}
        {fields.state}
        {fields.publicLiability}
        {fields.workerCompensation}
        {fields.website}
        {fields.email}
        {fields.phone}
        {isFreelanceCompany && fields.annualRevenue}
      </form>
    </div>
  );
};
export default UpdateSettingsForm;
